function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
    };
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}
$(document).on('theme:cart:add',function (){
    console.log("added")
    setTimeout(function (){
        updateCartDrawer(true);
    },500)

});
function toggleCustomCartDrawer(triger){
    if(triger== 'open'){
        $('#custom-cart-drawer').addClass('open');
        $('body').addClass('custom-modal-open')
        $('.site-header.redesign').removeClass('site-header--transparent');
    }else if(triger== 'close'){
        $('#custom-cart-drawer').removeClass('open');
        $('body').removeClass('custom-modal-open');
        if(!$('body').hasClass('has-scrolled') && $('body').hasClass('has-transparent-header')){
            $('.site-header.redesign').addClass('site-header--transparent');
        }
    }
}

$(document).on('click','.js-cart-drawer-close',function (){
    toggleCustomCartDrawer('close')
});
$('.js-custom-cart-trigger[data-cart-drawer-toggle]').on('click',function (e){
    e.preventDefault();
    setTimeout(function (){
    toggleCustomCartDrawer('open');
    },500)
});
function Update_cart_count() {
    jQuery.getJSON('/cart.js', function (cart) {
        if(window.cart_group_set){
            let count=0;
            let has_set_creator=false;
            cart.items.forEach(function (element){
                if(Object.keys(element.properties).toString().toLowerCase() != 'set_creator'){
                    count+=element.quantity
                }else{
                    has_set_creator=true;
                }
            });
            if(has_set_creator){
                count+=1;
            }
            if(cart.item_count > 0){
                $('.js-custom-cart-trigger').addClass('cart__toggle--has-items');
            }else{
                $('.js-custom-cart-trigger').removeClass('cart__toggle--has-items');
            }
            $('.navlink-cart.cart__toggle .cart-count span').html(count);

            $('.js-custom-cart-trigger .cart-count span').html(count);
        }else{
            if(cart.item_count > 0){
                $('.js-custom-cart-trigger').addClass('cart__toggle--has-items');
            }else{
                $('.js-custom-cart-trigger').removeClass('cart__toggle--has-items');
            }
            $('.navlink-cart.cart__toggle .cart-count span').html(cart.item_count);

            $('.js-custom-cart-trigger .cart-count span').html(cart.item_count);
        }
    });
}
function updateCartDrawer(open,upsell){
    $('#custom-cart-drawer').addClass('kloading');
    fetch('/?section_id=custom-cart-drawer').then(function (response) {
        return response.text();
    }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        const cart = $(doc).find('#custom-cart-drawer')[0].innerHTML;
        $(document).find('#custom-cart-drawer')[0].innerHTML = cart;
        Update_cart_count();
        if(upsell != true){
            upsellProducts();
        }
        initCartSwatch();
        $('#custom-cart-drawer').removeClass('loading');
        if(open){
            toggleCustomCartDrawer('open');
        }
    }).catch(function (err) {
        console.error('Something went wrong.', err);
    });
}
function updateCartPage(upsell){
    $('#custom-cart-page').find('.custom-cart-content').addClass('loading');
    fetch(`${theme.routes.cart_url}`).then(function (response) {
        return response.text();
    }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        const cart = $(doc).find('#custom-cart-page')[0].innerHTML;
        $(document).find('#custom-cart-page')[0].innerHTML = cart;
        Update_cart_count();
        if(upsell != true){
            upsellProducts();
        }
        initCartSwatch();
        $('#custom-cart-page').find('.custom-cart-content').removeClass('loading');
    }).catch(function (err) {
        console.error('Something went wrong.', err);
    });
}
class CartRemove extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const index = this.closest('cart-item').getAttribute('data-item-index');
            this.closest('cart-item').updateCart(index, 0);
        });
    }
}
customElements.define('remove-item', CartRemove);
class CartSetRemove extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const index = this.closest('cart-set-item').getAttribute('data-item-index');
            this.updateSetProduct(index, 0);
        });
    }
    updateSetProduct(line,quantity) {
        $('#custom-cart-drawer').addClass('loading');
        let line_array = line.split('|')
        let formData = {
            updates: {},
        };
        line_array.forEach(function (item){
            if(item != '') {
                formData["updates"][item] = quantity;
            }
        })
        console.log(formData)
        fetch('/cart/update.js',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    // Error function
                    console.log("Error")
                    return;
                }
                console.log("Success")
                updateCartDrawer(false,false);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    errorMessage(resp){
        console.log((resp.description));
    }
}
customElements.define('remove-set-item', CartSetRemove);
class Cart extends HTMLElement{
    constructor() {
        super();
        const input = this.querySelector('.js-quantity-input');
        this.debouncedOnChange = debounce((element) => {
            let line= element.closest('cart-item').getAttribute('data-item-index');
            let quantity = element.value;
            this.updateCart(line,quantity);
        }, 300);
        let _this = this
        if(input){
            input.addEventListener('countChange', function (){
                _this.debouncedOnChange(this)
            });
        }
    }

    updateCart(line,quantity) {
        $('#custom-cart-page').find('.custom-cart-content').addClass('loading');
        const body = JSON.stringify({
            line: line,
            quantity: quantity
        });
        fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const statejson =JSON.parse(state)
                updateCartDrawer();
                if(statejson.item_count < parseInt(quantity,10)){
                    let errorMessage = theme.strings.limit_error.replace(
                        '[quantity]',
                        statejson.item_count
                    );
                    console.log((errorMessage));
                }

            }) .catch((e) => {
            console.error(e);
        });
    }
    errorMessage(resp){
        console.log((resp.description));
    }
}
customElements.define('cart-item', Cart )

class CartPageRemove extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const index = this.closest('cart-page-item').getAttribute('data-item-index');
            this.closest('cart-page-item').updateCart(index, 0);
        });
    }
}
customElements.define('remove-cart-item', CartPageRemove);
class CartPageSetRemove extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('click', (event) => {
            event.preventDefault();
            const index = this.closest('cart-page-set-item').getAttribute('data-item-index');
            this.updateSetProduct(index, 0);
        });
    }
    updateSetProduct(line,quantity) {
        $('#custom-cart-page').find('.custom-cart-content').addClass('loading');
        let line_array = line.split('|')
        let formData = {
            updates: {},
        };
        line_array.forEach(function (item){
            if(item != '') {
                formData["updates"][item] = quantity;
            }
        })
        console.log(formData)
        fetch('/cart/update.js',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    // Error function
                    console.log("Error")
                    return;
                }
                console.log("Success")
                updateCartPage(false);
            })
            .catch((error) => {
                console.log(error);
            });
    }
    errorMessage(resp){
        console.log((resp.description));
    }
}
customElements.define('remove-cart-set-item', CartPageSetRemove);
class CartPage extends HTMLElement{
    constructor() {
        super();
        const input = this.querySelectorAll('.js-quantity-input');
        this.debouncedOnChange = debounce((element) => {
            let line= element.closest('cart-page-item').getAttribute('data-item-index');
            let quantity = element.value;
            this.updateCart(line,quantity);
        }, 300);
        let _this = this
        if(input){
            input.forEach(function (element){
                element.addEventListener('countChange', function (){
                    _this.debouncedOnChange(this)
                });
            });
        }
    }

    updateCart(line,quantity) {

        $('#custom-cart-drawer').addClass('loading');
        const body = JSON.stringify({
            line: line,
            quantity: quantity
        });
        fetch(`${theme.routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const statejson =JSON.parse(state)
                updateCartPage();
                if(statejson.item_count < parseInt(quantity,10)){
                    let errorMessage = theme.strings.limit_error.replace(
                        '[quantity]',
                        statejson.item_count
                    );
                    console.log((errorMessage));
                }
            }) .catch((e) => {
            console.error(e);
        });
    }
    errorMessage(resp){
        console.log((resp.description));
    }
}
customElements.define('cart-page-item', CartPage )


$(document).mouseup(function(e)
{
    var container = $("#custom-cart-drawer .overflow");
    if (container.is(e.target))
    {
        toggleCustomCartDrawer('close');
    }
});


function upsellProducts(){
     jQuery.getJSON('/cart.js', function (cart) {
        let AddDataItems = [];
        let RemoveDataItems = [];
        window.upsell.forEach(function (item){
            if(item.id != undefined){
                if(cart.total_price > item.price){
                    let hasUpsellitem = cart.items.find(element => element.variant_id === item.id);
                    if(hasUpsellitem == undefined) {
                        AddDataItems.push({'id':item.id,'quantity': 1,properties: {'upsellingbar_tag': `Bonus for cart value`}})
                    }
                }else if(cart.total_price < item.price){
                    let hasUpsellitem = cart.items.find(element => element.variant_id === item.id);
                    if(hasUpsellitem != undefined){
                        RemoveDataItems.push({'line':hasUpsellitem.key,'quantity': 0})
                    }
                }
            }
        });
        if(AddDataItems.length > 0){
            addUppsell(AddDataItems);
        }
        if(RemoveDataItems.length > 0){
            removeUppsell(RemoveDataItems);
        }

    });
}
function addUppsell(items){
    let formData = {
        items
    };
    fetch('/cart/add.js',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then((response) => response.json())
        .then((response) => {
            if (response.status) {
                // Error function
                console.log("Error")
                return;
            }
            console.log("Success")
            updateCartDrawer(false,true);
            if(location.href.includes('cart')){
                updateCartPage(true);
            }
        })
        .catch((error) => {
            console.log(error);
        });
}
function removeUppsell(items){
    let formData = {
        updates: {},
    };
    items.forEach(function (item){
        formData["updates"][item.line]=item.quantity;
    })
    console.log(formData)
        fetch('/cart/update.js',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    // Error function
                    console.log("Error")
                    return;
                }
                console.log("Success")
                updateCartDrawer(false,true);
                if(location.href.includes('cart')){
                    updateCartPage(true);
                }
            })
            .catch((error) => {
                console.log(error);
            });

}